import TextField from '@material-ui/core/TextField';
import { Grid, Typography } from '@mui/material';
import { ChangeEvent, useEffect, useState } from 'react';
import { ButtonOne } from '../../components/ButtonOne/ButtonOne.component';
import { useStyles } from './SolutionCard.styles';

interface EditDetailsProps {
  examineeIdentifier: string;
  onCancel(): void;
  onSave(newExamineeIdentifier: string): void;
}

export const EditDetails: React.FC<EditDetailsProps> = (props) => {
  const classes = useStyles();

  const [examineeIdentifier, setExamineeIdentifier] = useState<string>(props.examineeIdentifier);

  const [valid, setValid] = useState<boolean>(false);

  const isEmpty = (fieldValue: string): boolean => {
    return fieldValue === undefined || fieldValue.length === 0;
  };

  const isModified = (fieldValue: string, originalValue: string): boolean => {
    return fieldValue !== originalValue;
  };

  useEffect(() => {
    if (isEmpty(examineeIdentifier)) {
      setValid(false);
    } else if (isModified(examineeIdentifier, props.examineeIdentifier)) {
      setValid(true);
    } else setValid(false);
  }, [examineeIdentifier]);

  return (
    <>
      <Grid container className={classes.paddedContainer}>
        <Typography>Edytuj szczegóły karty:</Typography>
        <TextField
          id="examineeIdentifier"
          label="ID zdającego"
          value={examineeIdentifier}
          variant={'outlined'}
          size={'small'}
          margin={'normal'}
          fullWidth
          onChange={(event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
            setExamineeIdentifier(event.target.value)
          }
        />
      </Grid>
      <div className={classes.editDetailsButton}>
        <ButtonOne variant="outlined" color="primary" onClick={props.onCancel} style={{ marginRight: '10px' }}>
          Anuluj
        </ButtonOne>
        <ButtonOne
          disabled={!valid}
          variant="contained"
          color="primary"
          onClick={() => props.onSave(examineeIdentifier)}
        >
          Zapisz
        </ButtonOne>
      </div>
    </>
  );
};
